const projectsFilter = {
  _categoryName: undefined,
  _filtersCount: 0
}
Object.defineProperty(projectsFilter, 'categoryName', {
  enumerable: true,
  get () {
    return this._categoryName
  },
  set (v) {
    if (v === undefined) this._filtersCount -= 1
    else if (this._categoryName === undefined) this._filtersCount += 1
    this._categoryName = v
  }
})
Object.defineProperty(projectsFilter, 'filterCount', {
  enumerable: true,
  get () {
    return this._filtersCount
  }
})

export default projectsFilter
